import { type createPalette, PaletteButton } from '@gitbook/react-uikit';
import { Icon } from '@gitbook/spine-icons';
import {
    Button,
    DatePicker,
    type DatePickerProps,
    Divider,
    FieldGroup,
    Label,
    Popover,
    PopoverRoot,
    PopoverTrigger,
    usePopoverTriggerState,
} from '@gitbook/spine-react';

/**
 * Provides a DatePicker with a divider and room below for actions to be passed.
 */
export function UpdatesDateMenu(
    props: DatePickerProps & {
        formattedDate: string;
        createFormatPalette: () => ReturnType<typeof createPalette>;
    }
) {
    const { createFormatPalette, formattedDate, ...datePickerProps } = props;
    const datePickerPopover = usePopoverTriggerState();

    return (
        <PopoverRoot>
            <PopoverTrigger>
                <Button
                    kind="blank"
                    label={formattedDate}
                    onPress={() => datePickerPopover.open()}
                />
            </PopoverTrigger>
            <Popover placement="bottom-start" offset={12} className="p-2">
                <DatePicker
                    {...datePickerProps}
                    onChange={(date) => {
                        datePickerProps.onChange(date);
                        datePickerPopover.close();
                    }}
                />
                <Divider className="my-2" />
                <FieldGroup orientation="horizontal">
                    <Label className="flex gap-3 text-ui-small">Date format</Label>
                    <PaletteButton
                        kind="blank"
                        size="small"
                        trailingIcon={Icon.ChevronRight}
                        palette={createFormatPalette}
                        label={formattedDate}
                    />
                </FieldGroup>
            </Popover>
        </PopoverRoot>
    );
}
